// This file is auto-generated by @hey-api/openapi-ts

export type CategorySchema = {
    id: number;
    softwareCount: number;
    allSoftwareCount: number;
    order: number;
    name: string;
    slug: string;
    parent_id?: number | null;
};

export type InstalledComponentsSchema = {
    filename: string;
    version: string;
};

export type SaveInstalledSoftwareRequestSchema = {
    userUuid: string;
    installedComponents: Array<InstalledComponentsSchema>;
};

export type SoftwareFilterSchema = {
    category__in?: Array<(number)>;
    category?: string;
    status?: string;
    status_not?: string;
};

export type SoftwareListSchema = {
    id: number;
    status: SoftwareStatus;
    slug: string;
    vendorSlug: string;
    name: string;
    vendor?: string;
    category_id?: number | null;
    /**
     * Short description for the list page
     */
    shortDescription?: string;
    cover?: string | null;
    createdAt: string;
    modifiedAt: string;
};

export enum SoftwareStatus {
    BLANK = 'blank',
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    REJECTED = 'rejected',
    PENDING = 'pending',
    ERROR = 'error',
    VENDOR_PAYWALL = 'vendor_paywall'
}

export type SoftwareSchema = {
    id: number;
    status: SoftwareStatus;
    allowedExtensions: Array<(string)>;
    youtubeReviewsUrls: Array<(string)>;
    youtubeTutorialsUrls: Array<(string)>;
    youtubeOtherUrls: Array<(string)>;
    documentationUrls: Array<(string)>;
    slug: string;
    vendorSlug: string;
    name: string;
    vendor?: string;
    category_id?: number | null;
    description?: string;
    /**
     * Short description for the list page
     */
    shortDescription?: string;
    cover?: string | null;
    url?: string;
    /**
     * Use <b>%USER_FOLDER%</b> to refer to the user's home folder, e.g.  <b>%USER_FOLDER%/Library/Audio/Presets/MySoftware.</b><br/>Note: <b>%USER_FOLDER%</b>  doesn't contain a trailing slash.
     */
    macPresetsFolder?: string | null;
    /**
     * Use <b>%USER_FOLDER%</b> to refer to the user's home folder, e.g.  <b>%USER_FOLDER%/Library/Audio/Presets/MySoftware.</b><br/>Note: <b>%USER_FOLDER%</b>  doesn't contain a trailing slash.
     */
    macPresetsUserOwnedFolder?: string | null;
    rating?: number;
    /**
     * Internal comments for the team
     */
    internalNotes?: string;
    createdAt: string;
    modifiedAt: string;
};

export type VersionSchema = {
    id: number;
    components: Array<(string)>;
    macInstallOrder: Array<(string)>;
    software_id: number;
    version?: string;
    platform?: string;
    url?: string;
    status?: string;
    createdAt: string;
    modifiedAt: string;
    created_by_id?: number | null;
    modified_by_id?: number | null;
};

export type Input = {
    limit?: number;
    offset?: number;
};

export type SoftwareFilter = {
    category?: Array<(number)>;
    status?: 'blank' | 'enabled' | 'disabled' | 'rejected' | 'pending' | 'error' | 'vendor_paywall';
};

export type AdminSoftwareListSchema = {
    id: number;
    status: SoftwareStatus;
    lastValidVersion: string;
    createdByEmail: string;
    descriptionOk: boolean;
    youtubeReviewsUrls: Array<(string)>;
    youtubeTutorialsUrls: Array<(string)>;
    documentationUrls: Array<(string)>;
    name: string;
    category_id?: number | null;
    cover?: string | null;
    url?: string;
    vendor?: string;
    createdAt: string;
    modifiedAt: string;
    /**
     * Internal comments for the team
     */
    internalNotes?: string;
};

export type PagedAdminSoftwareListSchema = {
    items: Array<AdminSoftwareListSchema>;
    count: number;
};

export type SoftwareCreateSchema = {
    name: string;
};

export type AdminSoftwareUpdateSchema = {
    youtubeReviewsUrls: Array<(string)>;
    youtubeTutorialsUrls: Array<(string)>;
    youtubeOtherUrls: Array<(string)>;
    documentationUrls: Array<(string)>;
    name: string;
    category_id?: number | null;
    status?: string;
    description?: string;
    url?: string;
    vendor?: string;
    /**
     * Internal comments for the team
     */
    internalNotes?: string;
};

export type AdminVersionUpdateSchema = {
    components: Array<(string)>;
    macInstallOrder: Array<(string)>;
    version?: string;
    url?: string;
};

export type AdminUpdateCategorySchema = {
    order: number;
    parent_id: number | null;
    name: string;
    id?: number | null;
};

export type CategoriesApiListResponse = Array<CategorySchema>;

export type CategoriesApiGetData = {
    id: number;
};

export type CategoriesApiGetResponse = CategorySchema;

export type InstalledSoftwareApiSaveInstalledSoftwareData = {
    requestBody: SaveInstalledSoftwareRequestSchema;
};

export type InstalledSoftwareApiSaveInstalledSoftwareResponse = string;

export type SoftwareApiListData = {
    category?: string;
    categoryIn?: Array<(number)>;
    limit?: number;
    order?: string;
    search?: string;
    status?: string;
    statusNot?: string;
};

export type SoftwareApiListResponse = Array<SoftwareListSchema>;

export type SoftwareApiGetData = {
    id: number;
};

export type SoftwareApiGetResponse = SoftwareSchema;

export type SoftwareApiGetSofwareVersionsData = {
    id: number;
};

export type SoftwareApiGetSofwareVersionsResponse = Array<VersionSchema>;

export type SoftwareApiGetLatestSofwareVersionsData = {
    id: number;
};

export type SoftwareApiGetLatestSofwareVersionsResponse = Array<VersionSchema>;

export type SoftwareAdminApiListData = {
    category?: Array<(number)>;
    limit?: number;
    offset?: number;
    ordering?: string;
    query?: string;
    status?: 'blank' | 'enabled' | 'disabled' | 'rejected' | 'pending' | 'error' | 'vendor_paywall';
};

export type SoftwareAdminApiListResponse = PagedAdminSoftwareListSchema;

export type SoftwareAdminApiStatusesResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiCreateData = {
    requestBody: SoftwareCreateSchema;
};

export type SoftwareAdminApiCreateResponse = SoftwareSchema;

export type SoftwareAdminApiUploadCoverFileData = {
    id: number;
};

export type SoftwareAdminApiUploadCoverFileResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiUploadFileData = {
    formData: {
        file: (Blob | File);
        folder: string;
    };
};

export type SoftwareAdminApiUploadFileResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiUpdateData = {
    id: number;
    requestBody: AdminSoftwareUpdateSchema;
};

export type SoftwareAdminApiUpdateResponse = SoftwareSchema;

export type SoftwareAdminApiCreateVersionData = {
    softwareId: number;
};

export type SoftwareAdminApiCreateVersionResponse = string;

export type SoftwareAdminApiUpdateVersionData = {
    id: number;
    requestBody: AdminVersionUpdateSchema;
};

export type SoftwareAdminApiUpdateVersionResponse = VersionSchema;

export type SoftwareAdminApiUpdateCategoryData = {
    requestBody: Array<AdminUpdateCategorySchema>;
};

export type SoftwareAdminApiUpdateCategoryResponse = Array<AdminUpdateCategorySchema>;

export type VersionsApiGetData = {
    id: number;
};

export type VersionsApiGetResponse = VersionSchema;

export type $OpenApiTs = {
    '/api/categories/': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<CategorySchema>;
            };
        };
    };
    '/api/categories/{id}/': {
        get: {
            req: CategoriesApiGetData;
            res: {
                /**
                 * OK
                 */
                200: CategorySchema;
            };
        };
    };
    '/api/installed-software/save/': {
        post: {
            req: InstalledSoftwareApiSaveInstalledSoftwareData;
            res: {
                /**
                 * OK
                 */
                200: string;
            };
        };
    };
    '/api/software/': {
        get: {
            req: SoftwareApiListData;
            res: {
                /**
                 * OK
                 */
                200: Array<SoftwareListSchema>;
            };
        };
    };
    '/api/software/{id}/': {
        get: {
            req: SoftwareApiGetData;
            res: {
                /**
                 * OK
                 */
                200: SoftwareSchema;
            };
        };
    };
    '/api/software/{id}/versions/': {
        get: {
            req: SoftwareApiGetSofwareVersionsData;
            res: {
                /**
                 * OK
                 */
                200: Array<VersionSchema>;
            };
        };
    };
    '/api/software/{id}/latest_versions/': {
        get: {
            req: SoftwareApiGetLatestSofwareVersionsData;
            res: {
                /**
                 * OK
                 */
                200: Array<VersionSchema>;
            };
        };
    };
    '/api/software-admin/': {
        get: {
            req: SoftwareAdminApiListData;
            res: {
                /**
                 * OK
                 */
                200: PagedAdminSoftwareListSchema;
            };
        };
    };
    '/api/software-admin/statuses/': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/software/': {
        post: {
            req: SoftwareAdminApiCreateData;
            res: {
                /**
                 * OK
                 */
                200: SoftwareSchema;
            };
        };
    };
    '/api/software-admin/software/{id}/upload-cover-file/': {
        post: {
            req: SoftwareAdminApiUploadCoverFileData;
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/upload-file/': {
        post: {
            req: SoftwareAdminApiUploadFileData;
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/software/{id}/': {
        put: {
            req: SoftwareAdminApiUpdateData;
            res: {
                /**
                 * OK
                 */
                200: SoftwareSchema;
            };
        };
    };
    '/api/software-admin/software/{software_id}/create_version/': {
        post: {
            req: SoftwareAdminApiCreateVersionData;
            res: {
                /**
                 * OK
                 */
                200: string;
            };
        };
    };
    '/api/software-admin/version/{id}/': {
        put: {
            req: SoftwareAdminApiUpdateVersionData;
            res: {
                /**
                 * OK
                 */
                200: VersionSchema;
            };
        };
    };
    '/api/software-admin/categories/': {
        put: {
            req: SoftwareAdminApiUpdateCategoryData;
            res: {
                /**
                 * OK
                 */
                200: Array<AdminUpdateCategorySchema>;
            };
        };
    };
    '/api/versions/{id}/': {
        get: {
            req: VersionsApiGetData;
            res: {
                /**
                 * OK
                 */
                200: VersionSchema;
            };
        };
    };
};